<template>
<div v-show="isLocationSwitchNotificationModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
            <!-- Modal Header -->
            <div class="row p-1">
                <div class="hcol_1">
                    <div class="modal-title">{{ userFullName }}</div>
                </div>
                <div class="hcol_2">
                    <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                </div>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="row justify-content-center">
                    <div class="notify_message">
                        {{ notifyMessage }}
                    </div>
                    <div class="mt-4">
                        <button class="btn btn-sm confirmBtn float-right" @click="closeModal">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['isLocationSwitchNotificationModalVisible', 'userFullName', 'notifyMessage'],
    data() {
        return {
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
    },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #00acee;
  font-size: 1.2rem;
  font-weight: 900;
}
.modal-header {
  padding: 5px;
  border-bottom: 0px;
  margin-bottom: 10px;
  text-align: center !important;
}
.modal-body {
  padding: 5px;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.hcol_1 { width: 90%; }
.hcol_2 { width: 10%; }
.notify_message {  font-size: 1rem; }
.confirmBtn, .confirmBtn:focus, .confirmBtn:active, .confirmBtn:hover {
  color: #FFF !important;
  background: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/location_switch_notification_modal.vue